//import node_modules
import React, { FunctionComponent, PropsWithChildren } from "react";
import readingTime, { ReadTimeResults } from "reading-time";
import { Container } from "react-bootstrap";

//layout
import SiteLayout from "src/layouts/SiteLayout";

//meta
import MetadataComponent from "./components/MetadataComponent";

//locals
import ShareLinksComponent from "./components/ShareLinksComponent";
import RecommendationBlogsComponent from "./components/RecommendationComponent";
import PublishedComponent from "./components/PublishedComponent";

//styles
import { horizontalRowCSS } from "@adjust/website/src/styles/shared";

//types
import type { BlogDocument } from "@adjust/libs/database/blogs";
import { useCallback } from "react";
import { useState } from "react";

function useReader(): [(node: HTMLDivElement) => void, ReadTimeResults | undefined] {
  const [time, setTime] = useState<ReadTimeResults | undefined>(undefined);
  const ref = useCallback((node?: HTMLDivElement) => {
    if (!node) return;
    const text = node.innerText;
    const time = readingTime(text);
    setTime(time);
  }, []);
  return [ref, time];
}

export type BlogLayoutProps = {
  blog: BlogDocument;
  recommendations: BlogDocument[];
};

const BlogLayout: FunctionComponent<PropsWithChildren<BlogLayoutProps>> = ({ blog, recommendations, children }) => {
  const [ref, read_time] = useReader();

  return (
    <SiteLayout>
      <MetadataComponent blog={blog} />
      <Container className="text-center my-4">
        <div className="h4">
          <span>By </span>
          <span>{blog.authors.join(", ")}</span>
        </div>
        <PublishedComponent published_time={blog.publishedTime} read_time={read_time} />
        <div className={horizontalRowCSS} />
      </Container>
      <main ref={ref}>{children}</main>
      <ShareLinksComponent title={blog.title} description={blog.description} slug={blog.slug} image={blog.image} />
      <RecommendationBlogsComponent recommendations={recommendations} />
    </SiteLayout>
  );
};

export default React.memo(BlogLayout);
